@if (dateFacturation) {
  <span class="invoice-day" title="Facturation ou fin de mois validée">{{cellData.text}}</span>
} @else if (dateSaisieEffectif) {
  <span class="saisie-effectifs-day" title="Menus validés">{{cellData.text}}</span>
} @else if (dateCreationMenu) {
  <span class="creation-menus-day" title="Menus en cours de saisie">{{cellData.text}}</span>
} @else {
  <div title="Aucun menu">{{cellData.text}}</div>
}
